import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ontruck/orc';
import { useConversation } from 'hooks/useConversation/useConversation';
import { CHAT_ROUTES } from 'utils/constants/chat';

const ChatContainer = ({
  className,
  title,
  subtitle,
  handleBack,
  children
}) => {
  const { handleGoToRoute } = useConversation();

  return (
    <div className={className} data-testid="chat-container">
      <div className="chat-container">
        <button
          className="chat-container__close"
          data-testid="chat-container__close"
          onClick={() => handleGoToRoute(CHAT_ROUTES.CLOSED)}
        >
          <Icon glyph="close-thin" size="1.6rem" />
        </button>
        <div className="chat-container__header">
          {handleBack && (
            <button
              className="chat-container__back"
              onClick={handleBack}
              data-testid="chat-container__back"
            >
              <Icon glyph="previous" size="2rem" />
            </button>
          )}
          <div className="chat-container__header-titles">
            {title && (
              <p
                className="chat-container__title"
                data-testid="chat-container__title"
              >
                {title}
              </p>
            )}
            {subtitle && (
              <p
                className="chat-container__subtitle"
                data-testid="chat-container__subtitle"
              >
                {subtitle}
              </p>
            )}
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

ChatContainer.defaultProps = {
  title: '',
  subtitle: '',
  handleBack: null,
  withPadding: false,
  invertTitles: false
};

ChatContainer.propTypes = {
  className: PropTypes.string.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  handleBack: PropTypes.func,
  withPadding: PropTypes.bool,
  invertTitles: PropTypes.bool
};

export default ChatContainer;
